import { useEffect } from 'react';
import { Platform } from 'react-native';

import { PRESENCE_GLOW_CSS } from '@/common/components/presence/presenceGlowStyles';

let presenceGlowStylesInjected = false;

/**
 * Injects unified presence glow CSS once on web. No-op on native.
 */
export function PresenceGlowStylesInjector() {
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') {
      return undefined;
    }
    const existing = document.head?.querySelector('style[data-presence-glow-css]');
    if (existing) {
      existing.textContent = PRESENCE_GLOW_CSS;
      presenceGlowStylesInjected = true;
      return undefined;
    }
    if (presenceGlowStylesInjected) {
      return undefined;
    }
    const style = document.createElement('style');
    if (typeof style.setAttribute !== 'function' || !document.head?.appendChild) {
      return undefined;
    }
    style.setAttribute('data-presence-glow-css', 'true');
    style.textContent = PRESENCE_GLOW_CSS;
    document.head.appendChild(style);
    presenceGlowStylesInjected = true;
    return undefined;
  }, []);

  return null;
}
